import genericStore from '../generic_store';
import axios from 'axios';
import { config } from '@/config/constants.js';

export default {
  namespaced: genericStore.namespaced,
  state: {
    ...genericStore.state,
    endpoint: 'users',
    object: 'user',
    header: [
      { text: 'Nombres', value: 'first_name' },
      { text: 'Apellidos', value: 'last_name' },
      { text: 'Email', value: 'email' },
      { text: 'Compró?', value: 'hasApprovedOrder' },
      { text: 'Argentino?', value: 'country_id' },
      // { text: 'Foto de Perfil', value: 'profile_picture' },
      { text: 'Professionales', value: 'professionals' },
      { text: 'Acciones', value: 'actions', sortable: false },
    ],
    types: [
      { id: 'user', name: 'Usuario' },
      { id: 'professional', name: 'Profesional' },
      { id: 'user_family', name: 'Familiar' },
    ],
    options: {
      sortBy: ['_id'],
      sortDesc: [true],
    },
  },
  mutations: {
    ...genericStore.mutations,
  },
  actions: {
    ...genericStore.actions,
    getRoles({ commit }) {
      return new Promise((resolve, reject) => {
        commit('request');
        axios
          .get(config.api_url + 'roles')
          .then((response) => {
            commit('success', { roles: response.data });
            resolve(response.data);
          })
          .catch((err) => {
            commit('error');
            reject(err);
          });
      });
    },
  },
  getters: {
    ...genericStore.getters,
  },
};
